import { render, staticRenderFns } from "./addSlot.vue?vue&type=template&id=f611dd7a"
import script from "./addSlot.vue?vue&type=script&lang=js"
export * from "./addSlot.vue?vue&type=script&lang=js"
import style0 from "./addSlot.vue?vue&type=style&index=0&id=f611dd7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports